export const COMPUTE_FACILITY_NEXT_STATES_STARTED = "COMPUTE_FACILITY_NEXT_STATES_STARTED";
export const COMPUTE_FACILITY_NEXT_STATES_SUCCESS = "COMPUTE_FACILITY_NEXT_STATES_SUCCESS";
export const COMPUTE_FACILITY_NEXT_STATES_FAILED = "COMPUTE_FACILITY_NEXT_STATES_FAILED";
